import SectionList from './SectionList';
import Utils from '../Services/Utils';
import SelectOptions from '../Services/SelectOptions';
import { SCORE_OPTIONS_AVERAGE } from '../Context/DynamicFormContext';

class DynamicForm {
  constructor(item = {}) {
    const scoreType = !Utils.isNull(item.score_type) ? item.score_type : item.scoreType;
    this.account = item.account || undefined;
    this.sectors = item.sectors || [];
    this.name = item.name || undefined;
    this.description = item.description || undefined;
    if (!Utils.isNull(scoreType)) {
      this.scoreType = (Utils.isNull(scoreType.value) ? SelectOptions.getValue(SCORE_OPTIONS_AVERAGE, scoreType) : scoreType);
    }
    else {
      this.scoreType = { value: 0, label: 'No score' };
    }
    this.columns = !Utils.isNull(item.columns) ? item.columns : undefined;
    this.workflowStatistics = item.workflowStatistics || false;
    this.descriptionAsIcon = item.descriptionAsIcon || false;
    this.showTriggerConditionMet = item.showTriggerConditionMet || false;
    this.imagesLayout = item.imagesLayout || 0;
    this.required = item.required || false;
    this.showUnselectedCheckbox = item.showUnselectedCheckbox || false;
    this.sections = item.sections || undefined;
    this.id = item.id || undefined;
    this.isStaff = item.isStaff || false;
    this.clientInstance = item.clientInstance || null;
    this.disabled = !Utils.isNull(item.disabled) ? item.disabled : undefined;
    this.preview = !Utils.isNull(item.preview) ? item.preview : undefined;
    this.errors = {};
    this.locale = item.locale ? item.locale : undefined;
    this.created_in_language = item.created_in_language ? item.created_in_language : undefined;
    this.languages = item.languages ? item.languages : undefined;
    this.updated_in_language = item.updated_in_language ? item.updated_in_language : undefined;
  }

  static parse = async (item, disabled, chargeCodes) => {
    const scoreType = !Utils.isNull(item.score_type) ? item.score_type : item.scoreType;
    const showUnselectedCheckbox = !Utils.isNull(item.show_unselected_checkbox) ? item.show_unselected_checkbox : item.showUnselectedCheckbox;
    const showTriggerConditionMet = !Utils.isNull(item.show_trigger_condition_met) ? item.show_trigger_condition_met : item.showTriggerConditionMet;
    const descriptionAsIcon = !Utils.isNull(item.description_as_icon) ? item.description_as_icon : item.descriptionAsIcon;
    const workflowStatistics = !Utils.isNull(item.workflow_statistics) ? item.workflow_statistics : item.workflowStatistics;
    const imagesLayout = !Utils.isNull(item.images_layout) ? item.images_layout : item.imagesLayout;
    const sections = item.fields ? item.fields : item.sections;
    let scoreValue = null;
    if (!Utils.isNull(scoreType)) {
      scoreValue = (Utils.isNull(scoreType.value) ? SelectOptions.getValue(SCORE_OPTIONS_AVERAGE, scoreType) : scoreType);
    }
    else {
      scoreValue = { value: 0, label: 'No score' };
    }
    return new DynamicForm({
      account: item.account || undefined,
      sectors: item.sectors || [],
      name: item.name || undefined,
      description: item.description || undefined,
      scoreType: scoreValue,
      columns: !Utils.isNull(item.columns) ? item.columns : undefined,
      workflowStatistics: workflowStatistics || false,
      descriptionAsIcon: descriptionAsIcon || false,
      showTriggerConditionMet: showTriggerConditionMet || false,
      imagesLayout: imagesLayout || 0,
      required: item.required || false,
      showUnselectedCheckbox: showUnselectedCheckbox || false,
      sections: sections ? await SectionList.parse(sections, disabled, chargeCodes) : undefined,
      id: item.id || undefined,
      isStaff: item.isStaff,
      clientInstance: item.clientInstance,
      disabled: !Utils.isNull(item.disabled) ? item.disabled : undefined,
      preview: !Utils.isNull(item.preview) ? item.preview : undefined,
      locale: item.locale ? item.locale : undefined,
      created_in_language: item.created_in_language ? item.created_in_language : undefined,
      languages: item.languages ? item.languages : undefined,
      updated_in_language: item.updated_in_language ? item.updated_in_language : undefined
    });
  };

  serialize = (builder) => {
    const sectors = (this.sectors || []);
    let sectorsResults = [];
    if (sectors.length > 0) {
      sectors.map(item => {
        if (!Utils.isNull(item)) {
          sectorsResults.push(!Utils.isNull(item.value) ? item.value : item);
        }
      });
    }
    const sections = this.sections ? this.sections.serialize(builder) : undefined;
    return {
      account: this.account,
      sectors: sectorsResults,
      name: this.name,
      description: this.description,
      score_type: !Utils.isNull(this.scoreType) && !Utils.isNull(this.scoreType.value) ? this.scoreType.value : this.scoreType,
      columns: this.columns,
      workflow_statistics: this.workflowStatistics,
      description_as_icon: this.descriptionAsIcon,
      show_trigger_condition_met: this.showTriggerConditionMet,
      images_layout: this.imagesLayout,
      required: this.required,
      show_unselected_checkbox: this.showUnselectedCheckbox,
      fields: sections,
      client_instance: !Utils.isNull(this.clientInstance) && !Utils.isNull(this.clientInstance.value) ? this.clientInstance.value : this.clientInstance,
      fields_triggers: this._serializeTriggers(sections),
      locale: this.locale,
      created_in_language : this.created_in_language,
      languages: this.languages,
      updated_in_language: this.updated_in_language
    };
  };

  serializeAsync = async (builder) => {
    const sectors = (this.sectors || []);
    let sectorsResults = [];
    if (sectors.length > 0) {
      sectors.map(item => {
        if (!Utils.isNull(item)) {
          sectorsResults.push(!Utils.isNull(item.value) ? item.value : item);
        }
      });
    }
    const sections = this.sections ? await this.sections.serializeAsync(builder) : undefined;
    return {
      account: this.account,
      sectors: sectorsResults,
      name: this.name,
      description: this.description,
      score_type: !Utils.isNull(this.scoreType) && !Utils.isNull(this.scoreType.value) ? this.scoreType.value : this.scoreType,
      columns: this.columns,
      workflow_statistics: this.workflowStatistics,
      description_as_icon: this.descriptionAsIcon,
      show_trigger_condition_met: this.showTriggerConditionMet,
      images_layout: this.imagesLayout,
      required: this.required,
      show_unselected_checkbox: this.showUnselectedCheckbox,
      fields: sections,
      client_instance: !Utils.isNull(this.clientInstance) && !Utils.isNull(this.clientInstance.value) ? this.clientInstance.value : this.clientInstance,
      fields_triggers: this._serializeTriggers(sections),
      locale: this.locale ? this.locale : undefined,
      created_in_language: this.created_in_language,
      languages: this.languages,
      updated_in_language: this.updated_in_language
    };
  };

  _serializeTriggers(sections) {
    const triggers = {};
    sections.map((section) => {
      section.children.map((field) => {
        if (field.triggers && field.triggers.length) {
          triggers[field.groupId] = {
            component: field.component,
            field_id: field.id,
            group_id: field.groupId,
            section_id: field.section,
            triggers: field.triggers,
          };
        }
      });
    });
    return triggers;
  }

}

export default DynamicForm;